import { useState } from 'react';

function BtnPlay(props: any) {
    const [value, setValue] = useState(100);
    let progress = 0;
    if (props.loadingStatus)
        switch (props.loadingStatus.status) {
            case 'recordingsLoading':
                progress = props.loadingStatus.progress;
                return <div key="PlayBtn" className="MeterWrapper" style={{ padding: '.3rem .3rem 0 .3rem', position: 'relative' }}>
                    <span style={{ fontWeight: 'bold', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: 'white' }}>{Math.round(progress * 100) + '%'}</span>
                    <svg viewBox="0 0 49 49" fillRule="evenodd" clipRule="evenodd" style={{ cursor: 'pointer' }} strokeLinejoin="round" strokeMiterlimit="2">
                        <circle fill="#555" className={`SvgCircle `} cx="24.585" cy="24.585" r="24.585" />
                    </svg>
                </div >
            default:
        }
    if (props.playbackStatus) {
        switch (props.playbackStatus.status) {
            case 'enginePaused':
                return <div onClick={e => props.playerComponent.playbackStart()} key="PlayBtn" className="MeterWrapper" style={{ padding: '.3rem .3rem 0 .3rem', position: 'relative' }}>
                    <SvgPlay />
                </div>

            case 'enginePlaying':
                return <div onClick={e => props.playerComponent.playbackStop()} key="PlayBtn" className="MeterWrapper" style={{ padding: '.3rem .3rem 0 .3rem', position: 'relative' }}>
                    <SvgStop />
                </div>
            case 'engineBuffering':
                return <div onClick={e => props.playerComponent.playbackStop()} key="PlayBtn" className="MeterWrapper" style={{ padding: '.3rem .3rem 0 .3rem', position: 'relative' }}>
                    <SvgStop />
                </div>
            default:
        }
    }

    return <div key="PlayBtn" className="MeterWrapper" style={{ padding: '.3rem .3rem 0 .3rem', position: 'relative' }}>
        <SvgCircle />
    </div>
}

export default BtnPlay;

function SvgPlay() {
    return <svg viewBox="0 0 49 49" fillRule="evenodd" clipRule="evenodd" style={{ cursor: 'pointer' }}
        strokeLinejoin="round" strokeMiterlimit="2">
        <path className={`SvgCircle SvgPlay`}
            d="M24.314 0c13.419 0 24.313 10.895 24.313 24.314S37.733 48.627 24.314 48.627C10.895 48.627 0 37.733 0 24.314 0 10.895 10.895 0 24.314 0zm10.138 23.271a1.127 1.127 0 010 1.973l-16.318 9.011a1.129 1.129 0 01-1.672-.987V15.247a1.129 1.129 0 011.672-.987l16.318 9.011z"
            fill="#1BBF19" />
    </svg>
}

function SvgStop() {
    return <svg viewBox="0 0 49 49" fillRule="evenodd" clipRule="evenodd" style={{ cursor: 'pointer' }}
        strokeLinejoin="round" strokeMiterlimit="2">
        <path className={`SvgCircle SvgStop`}
            d="M24.314 0c13.419 0 24.313 10.895 24.313 24.314S37.733 48.627 24.314 48.627C10.895 48.627 0 37.733 0 24.314 0 10.895 10.895 0 24.314 0zm7.417 15.893a1.114 1.114 0 00-1.115-1.114h-2.629a1.116 1.116 0 00-1.114 1.114v16.841a1.115 1.115 0 001.114 1.114h2.629a1.113 1.113 0 001.115-1.114V15.893zm-9.559 0c0-.615-.499-1.114-1.114-1.114h-3.047c-.615 0-1.114.499-1.114 1.114v16.841c0 .615.499 1.114 1.114 1.114h3.047c.615 0 1.114-.499 1.114-1.114V15.893z"
            fill="tomato" />
    </svg>
}

function SvgCircle() {
    return <svg viewBox="0 0 49 49" fillRule="evenodd" clipRule="evenodd" style={{ cursor: 'pointer' }} strokeLinejoin="round" strokeMiterlimit="2">
        <circle className={`SvgCircle `} cx="24.585" cy="24.585" r="24.585" />
    </svg>
}


// style="fill:rgb(255,120,0);
export function SvgScroll(props: { onActiveChange: (active: boolean) => void }) {
    const [active, setActive] = useState(false);

    return <svg width="80%" height="80%" viewBox="0 0 50 50" style={{ cursor: 'pointer' }} onClick={() => {
        console.log('SvgScroll button', !active);
        props.onActiveChange(!active);
        setActive(!active);
    }} >
        < g transform="matrix(1,0,0,1,-1140.68,-264.832)" >
            <g transform="matrix(1,0,0,1,-164.052,190.789)">
                <circle cx="1329.32" cy="98.628" r="24.585" style={{ fill: active ? 'gray' : 'orange' }} >
                    <title>{!active ? 'Scroll ON' : 'Scroll OFF'}</title>
                </circle>
            </g>
            <path style={{ fill: 'white' }} d="M1174.92,272.946L1174.92,305.889C1174.92,306.532 1175.44,307.053 1176.08,307.053C1176.73,307.053 1177.25,306.532 1177.25,305.889L1177.25,272.946C1177.25,272.304 1176.73,271.782 1176.08,271.782C1175.44,271.782 1174.92,272.304 1174.92,272.946ZM1163.34,276.866C1163.41,276.837 1163.5,276.818 1163.58,276.812C1163.63,276.808 1163.68,276.809 1163.73,276.814C1164.05,276.842 1166.9,277.157 1169.2,279.414C1170.78,280.972 1172.13,283.46 1172.12,287.464C1172.12,287.523 1172.12,287.581 1172.11,287.638C1172.08,287.774 1172.02,287.899 1171.94,288.003L1171.93,288.016C1171.84,288.119 1171.73,288.202 1171.6,288.256C1171.53,288.287 1171.45,288.308 1171.37,288.317L1171.36,288.317C1171.28,288.326 1171.19,288.321 1171.11,288.306C1170.98,288.279 1170.85,288.22 1170.75,288.137L1170.74,288.126C1170.63,288.041 1170.55,287.931 1170.5,287.803C1170.47,287.751 1170.46,287.696 1170.45,287.639C1170.4,287.444 1169.78,284.668 1168.25,282.532C1167.48,281.446 1166.45,280.511 1165.11,280.303L1168.29,294.391L1168.38,294.514C1168.59,295.534 1168.19,296.713 1167.18,298.05C1166.16,299.387 1165.03,300.187 1163.79,300.448C1163.27,300.558 1162.76,300.597 1162.26,300.567C1161.76,300.537 1161.25,300.335 1160.72,299.961C1160.2,299.587 1159.86,299.039 1159.71,298.316C1159.47,297.203 1159.86,296.003 1160.87,294.716C1161.87,293.429 1163.02,292.651 1164.3,292.381C1164.8,292.276 1165.3,292.237 1165.81,292.265C1165.9,292.272 1165.99,292.283 1166.08,292.3L1162.82,277.857C1162.81,277.812 1162.8,277.766 1162.8,277.718C1162.79,277.634 1162.8,277.551 1162.82,277.471C1162.85,277.333 1162.91,277.209 1163,277.106L1163.01,277.1C1163.09,276.998 1163.21,276.917 1163.34,276.866ZM1147.68,296.984L1155.27,296.984C1155.91,296.984 1156.43,296.463 1156.43,295.821C1156.43,295.179 1155.91,294.657 1155.27,294.657L1147.68,294.657C1147.04,294.657 1146.52,295.179 1146.52,295.821C1146.52,296.463 1147.04,296.984 1147.68,296.984ZM1147.11,290.81L1158.59,290.81C1159.23,290.81 1159.75,290.288 1159.75,289.646C1159.75,289.004 1159.23,288.483 1158.59,288.483L1147.11,288.483C1146.46,288.483 1145.94,289.004 1145.94,289.646C1145.94,290.288 1146.46,290.81 1147.11,290.81ZM1151.06,284.635L1158.64,284.635C1159.28,284.635 1159.81,284.114 1159.81,283.472C1159.81,282.83 1159.28,282.309 1158.64,282.309L1151.06,282.309C1150.41,282.309 1149.89,282.83 1149.89,283.472C1149.89,284.114 1150.41,284.635 1151.06,284.635Z" />
        </g >
    </svg >
}
